import { lazy } from 'react';

export const LazyWeeksPage = lazy(() =>
  import('../pages/WeeksPage').then((m) => ({ default: m.WeeksPage })),
);
export const LazyProfilePage = lazy(() =>
  import('../pages/ProfilePage').then((m) => ({ default: m.ProfilePage })),
);
export const LazyAboutPage = lazy(() =>
  import('../pages/AboutPage').then((m) => ({ default: m.AboutPage })),
);
export const LazyNotificationSettingsPage = lazy(() =>
  import('../pages/NotificationSettingsPage').then((m) => ({ default: m.NotificationSettingsPage })),
);
export const LazyCreateWeekPage = lazy(() =>
  import('../pages/CreateWeekPage').then((m) => ({ default: m.CreateWeekPage })),
);
export const LazyWeekDetailPage = lazy(() =>
  import('../pages/WeekDetailPage').then((m) => ({ default: m.WeekDetailPage })),
);
export const LazyWeekSetupWizard = lazy(() =>
  import('../pages/WeekSetupWizard').then((m) => ({ default: m.WeekSetupWizard })),
);
export const LazySkillsSelectionPage = lazy(() =>
  import('../pages/SkillsSelectionPage').then((m) => ({ default: m.SkillsSelectionPage })),
);
export const LazySelfEnquiryPage = lazy(() =>
  import('../pages/SelfEnquiryPage').then((m) => ({ default: m.SelfEnquiryPage })),
);
export const LazySelfEnquiryHistoryPage = lazy(() =>
  import('../pages/SelfEnquiryHistoryPage').then((m) => ({ default: m.SelfEnquiryHistoryPage })),
);
export const LazySelfEnquiryJournalDetailPage = lazy(() =>
  import('../pages/SelfEnquiryJournalDetailPage').then((m) => ({ default: m.SelfEnquiryJournalDetailPage })),
);
export const LazySocialSignalsTrackingPage = lazy(() =>
  import('../pages/SocialSignalsTrackingPage').then((m) => ({ default: m.SocialSignalsTrackingPage })),
);
export const LazyTrackerPage = lazy(() =>
  import('../pages/TrackerPage').then((m) => ({ default: m.TrackerPage })),
);
export const LazyPrivateBehaviorsTrackingPage = lazy(() =>
  import('../pages/PrivateBehaviorsTrackingPage').then((m) => ({ default: m.PrivateBehaviorsTrackingPage })),
);
export const LazyRiskFactorsTrackingPage = lazy(() =>
  import('../pages/RiskFactorsTrackingPage').then((m) => ({ default: m.RiskFactorsTrackingPage })),
);
export const LazyRadicallyOpenSkillsTrackingPage = lazy(() =>
  import('../pages/RadicallyOpenSkillsTrackingPage').then((m) => ({
    default: m.RadicallyOpenSkillsTrackingPage,
  })),
);
export const LazySelfEnquiryTrackingPage = lazy(() =>
  import('../pages/SelfEnquiryTrackingPage').then((m) => ({ default: m.SelfEnquiryTrackingPage })),
);
export const LazyArchivePage = lazy(() =>
  import('../pages/ArchivePage').then((m) => ({ default: m.ArchivePage })),
);
export const LazyArchiveWeekReviewPage = lazy(() =>
  import('../pages/ArchiveWeekReviewPage').then((m) => ({ default: m.ArchiveWeekReviewPage })),
);
export const LazyJournalPage = lazy(() =>
  import('../pages/JournalPage').then((m) => ({ default: m.JournalPage })),
);
